export default __webpack_public_path__ + "static/media/Billy_the_Artiste_blanc_porte_cle.c4d303c9.png";